var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuAgregar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.611,
    height: 239.657,
    viewBox: "0 0 331.611 239.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5719",
    "data-name": "Group 5719",
    transform: "translate(-542.943 -404.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5693",
    "data-name": "Group 5693",
    transform: "translate(542.943 404.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51532",
    "data-name": "Path 51532",
    d: "M756.136,234.861c-.838-6.144-1.888-12.741-6.222-17.176a14.572,14.572,0,0,0-21.055.218c-3.154,3.365-4.547,8.09-4.675,12.7s.9,9.17,2.038,13.64a42.041,42.041,0,0,0,17.545-3.453,28.269,28.269,0,0,1,4.207-1.652c1.462-.372,2.5.564,3.864,1.217l.746-1.429c.611,1.137,2.5.8,3.189-.293A5.637,5.637,0,0,0,756.136,234.861Z",
    transform: "translate(-495.507 -213.297)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51533",
    "data-name": "Path 51533",
    d: "M693.608,277.7l1.746-8.917-13.088-5.666-23.4-11.21a5.2,5.2,0,1,0-3.769,5.822l22.279,13.749Z",
    transform: "translate(-458.157 -230.189)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51534",
    "data-name": "Path 51534",
    d: "M720.218,294.706l9.479-9.69.187.057c.118.036,11.9,3.626,19.4,7.275a6.4,6.4,0,0,1,3.528,4.069,6.708,6.708,0,0,1-2.1,7.047,7.175,7.175,0,0,1-7.674,1.222Z",
    transform: "translate(-493.553 -248.709)",
    fill: "#1d3744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51535",
    "data-name": "Path 51535",
    d: "M447.684,150.018l26.656,7.123,5.383-25.181-24.466-7.573Z",
    transform: "translate(-221.048 -61.417)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51536",
    "data-name": "Path 51536",
    d: "M748.208,324.689,722.168,318.7l-4.986-12.085a9.245,9.245,0,0,1,3.334-9.423l9.514-8.032,5.1-6.515-.555-3.453a2.991,2.991,0,0,1,1.994-3.256l6.8-2.438a3.163,3.163,0,0,1,3.99,1.659l.72,1.667s3.074,1.446,4.807,2.26a6.956,6.956,0,0,1,3.762,4.262,35.264,35.264,0,0,1-2,25.9Z",
    transform: "translate(-491.933 -242.923)",
    fill: "#1d3744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51537",
    "data-name": "Path 51537",
    d: "M307.459,605.217l-12.59-3.369a42.051,42.051,0,0,1-.625-20.223c5.493,10.858,20.244,12.9,28.983,21.372a25.294,25.294,0,0,1,7.421,20.63l3.016,8.738a42.385,42.385,0,0,1-31.617-16.12,40.941,40.941,0,0,1-5.207-8.853C302.108,606.62,307.459,605.217,307.459,605.217Z",
    transform: "translate(-282.759 -395.162)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51538",
    "data-name": "Path 51538",
    d: "M497.723,503h-123.4a12.488,12.488,0,0,1-12.474-12.474v-163.4a12.488,12.488,0,0,1,12.474-12.474h123.4A12.488,12.488,0,0,1,510.2,327.134v163.4A12.488,12.488,0,0,1,497.723,503Z",
    transform: "translate(-316.605 -263.346)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51539",
    "data-name": "Path 51539",
    d: "M460.173,502.754H392.546A11.371,11.371,0,0,1,381.188,491.4V346a11.37,11.37,0,0,1,11.358-11.358H498.6A11.37,11.37,0,0,1,509.955,346V452.972a49.838,49.838,0,0,1-49.782,49.782Z",
    transform: "translate(-326.154 -273.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51540",
    "data-name": "Path 51540",
    d: "M506.711,384.378H421.818a2.769,2.769,0,0,1-.007-5.537h84.9a2.769,2.769,0,0,1,.007,5.537Z",
    transform: "translate(-344.846 -295.036)",
    fill: "#f37b33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51541",
    "data-name": "Path 51541",
    d: "M506.714,405.988H421.821a2.769,2.769,0,0,1,0-5.538h84.893a2.769,2.769,0,0,1,0,5.538Z",
    transform: "translate(-344.85 -305.706)",
    fill: "#f37b33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51542",
    "data-name": "Path 51542",
    d: "M458.62,427.6h-36.8a2.769,2.769,0,1,1,0-5.538h36.8a2.769,2.769,0,1,1,0,5.538Z",
    transform: "translate(-344.85 -316.377)",
    fill: "#f37b33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51543",
    "data-name": "Path 51543",
    d: "M506.711,472.861H421.818a2.769,2.769,0,0,1-.007-5.537h84.9a2.769,2.769,0,0,1,.007,5.537Z",
    transform: "translate(-344.846 -338.725)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51544",
    "data-name": "Path 51544",
    d: "M506.714,494.471H421.821a2.769,2.769,0,1,1,0-5.538h84.893a2.769,2.769,0,0,1,0,5.538Z",
    transform: "translate(-344.85 -349.395)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51545",
    "data-name": "Path 51545",
    d: "M458.62,516.082h-36.8a2.769,2.769,0,0,1,0-5.538h36.8a2.769,2.769,0,1,1,0,5.538Z",
    transform: "translate(-344.85 -360.066)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51546",
    "data-name": "Path 51546",
    d: "M506.711,561.343H421.818a2.769,2.769,0,1,1-.007-5.537h84.9a2.769,2.769,0,0,1,.007,5.537Z",
    transform: "translate(-344.846 -382.414)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51547",
    "data-name": "Path 51547",
    d: "M506.714,582.954H421.821a2.769,2.769,0,1,1,0-5.538h84.893a2.769,2.769,0,1,1,0,5.538Z",
    transform: "translate(-344.85 -393.085)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51548",
    "data-name": "Path 51548",
    d: "M458.62,604.565h-36.8a2.769,2.769,0,0,1,0-5.538h36.8a2.769,2.769,0,0,1,0,5.538Z",
    transform: "translate(-344.85 -403.755)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51560",
    "data-name": "Path 51560",
    d: "M35.994,0A35.994,35.994,0,1,1,0,35.994,35.994,35.994,0,0,1,35.994,0Z",
    transform: "translate(151.504 18.498)",
    fill: "#f37b33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51549",
    "data-name": "Path 51549",
    d: "M607.744,349.553A35.988,35.988,0,0,1,571.849,316.1c-.059.833-.1,1.676-.1,2.529a35.994,35.994,0,0,0,71.987,0c0-.853-.04-1.7-.1-2.534A35.989,35.989,0,0,1,607.744,349.553Z",
    transform: "translate(-420.246 -264.053)",
    fill: "#231f20",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51550",
    "data-name": "Path 51550",
    d: "M638.453,321.45a4.513,4.513,0,0,1-4.508-4.508V290.861a4.508,4.508,0,1,1,9.015,0v26.082A4.513,4.513,0,0,1,638.453,321.45Z",
    transform: "translate(-450.955 -249.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51551",
    "data-name": "Path 51551",
    d: "M608.185,316.621a4.513,4.513,0,0,1,4.508-4.508h26.082a4.508,4.508,0,0,1,0,9.015H612.693A4.513,4.513,0,0,1,608.185,316.621Z",
    transform: "translate(-438.236 -262.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51552",
    "data-name": "Path 51552",
    d: "M707.744,331.358l-7.659-4.888-10.063,10.106-19,17.672a5.2,5.2,0,1,0,4.038,5.638l20.948-15.7Z",
    transform: "translate(-466.139 -269.177)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51553",
    "data-name": "Path 51553",
    d: "M735.194,322.179l-5.549-12.368.122-.154c.076-.1,7.728-9.743,13.872-15.4a6.4,6.4,0,0,1,5.078-1.794,6.712,6.712,0,0,1,5.788,4.537,7.174,7.174,0,0,1-1.671,7.588Z",
    transform: "translate(-498.208 -252.374)",
    fill: "#1d3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 12.041,
    cy: 12.041,
    r: 12.041,
    transform: "translate(229.958 5.07)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51554",
    "data-name": "Path 51554",
    d: "M433.911,437.642h-4.978l-2.369-19.2h7.347Z",
    transform: "translate(-210.62 -206.61)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51555",
    "data-name": "Path 51555",
    d: "M701.737,674.5h-3.57l-.637-3.37L695.9,674.5H686.43a2.128,2.128,0,0,1-1.209-3.88l7.561-5.222v-3.407l7.953.475Z",
    transform: "translate(-475.819 -434.845)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51556",
    "data-name": "Path 51556",
    d: "M550.733,430.616l-4.625,1.841-9.3-16.963,6.826-2.717Z",
    transform: "translate(-265.053 -203.813)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51557",
    "data-name": "Path 51557",
    d: "M831.2,664.678,827.885,666l-1.839-2.9-.27,3.735-8.8,3.5a2.128,2.128,0,0,1-2.558-3.157l5.094-7.648-1.26-3.166,7.564-2.5Z",
    transform: "translate(-539.891 -430.833)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51558",
    "data-name": "Path 51558",
    d: "M707.3,517.38h-10.3L699.852,469l-2.08-32.79,0-.026,7.759-47a19.851,19.851,0,0,1,4.756-9.97l.094-.106,25.966,6.413,2.611,5.953c8.914,5.3,11.73,35.2,11.845,36.474l3.774,37.271,9.232,45.68-6.5,3.5-.109-.217L736.68,473.37l-12.962-43.04-8.3,38.737Z",
    transform: "translate(-482.092 -295.168)",
    fill: "#f37b33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51559",
    "data-name": "Path 51559",
    d: "M749.96,232.1a40.15,40.15,0,0,0-1.872-8.257,13.344,13.344,0,0,0-4.929-6.6c-3.665-2.364-8.409-1.908-12.518-.548a18.991,18.991,0,0,0-8.52,5.219,11.011,11.011,0,0,0-2.666,9.6l13.148-3.107-.48.339a10.586,10.586,0,0,1,5.65,7.363,10.968,10.968,0,0,1-2.314,9.109l8.967-3.181c1.845-.654,3.82-1.409,4.914-3.087C750.608,237,750.314,234.423,749.96,232.1Z",
    transform: "translate(-493.049 -214.422)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M273.108,685.242H603.456a.631.631,0,1,0,0-1.263H273.108a.631.631,0,0,0,0,1.263Z",
    transform: "translate(-272.476 -445.701)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuAgregar);
export default __webpack_public_path__ + "static/media/Docu_agregar.ca6a3711.svg";
export { ForwardRef as ReactComponent };